import axios from "axios";
import {API_URL} from "../constants";
import {authHeader} from "../Utilities";

export type RunInfo = {
    id: string,
    name: string,
    created_at: any,
    is_exposed: boolean
}

export type RunInfoVerbose = RunInfo & {
    total_pages: number,
    processed_pages: number
}

class ProcessingRunsService {
    async getRunInfo(projectId: string, runId: string): Promise<RunInfo> {
        return this.getRunInfoRaw(projectId, runId, false);
    }

    async getRunInfoVerbose(projectId: string, runId: string): Promise<RunInfoVerbose> {
        return this.getRunInfoRaw(projectId, runId, true);
    }

    private async getRunInfoRaw<T>(projectId: string, runId: string, verbose: boolean): Promise<T> {
        const response = await axios.get<T>(
            API_URL + `/projects/${projectId}/processing_runs/${runId}`,
            {
                params: {verbose},
                headers: authHeader()
            }
        )
        return response.data;
    }
}

export default new ProcessingRunsService();